import { render, staticRenderFns } from "./PolicyNumber.vue?vue&type=template&id=06226e45&scoped=true"
import script from "./PolicyNumber.vue?vue&type=script&lang=js"
export * from "./PolicyNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06226e45",
  null
  
)

export default component.exports